'use strict';

var React = require('react'),
    _ = require('underscore'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    SectionTypes = require('../constants/SectionTypes');

require('./LightboxOverlay.less');

var LightboxOverlay = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    stamp: React.PropTypes.object.isRequired,
    image: React.PropTypes.object.isRequired,
    color: React.PropTypes.oneOf(['dark', 'light']).isRequired,
    hideLightbox: React.PropTypes.func.isRequired,
    isInLightbox: React.PropTypes.bool.isRequired,
    sectionType: React.PropTypes.oneOf([
      SectionTypes.COVER,
      SectionTypes.GALLERY,
      SectionTypes.POSTER
    ]).isRequired
  },

  className: 'stamp-LightboxOverlay',

  getCSSModifiers: function () {
    return [
      this.props.sectionType
    ];
  },

  componentDidMount() {
    _.defer(this._triggerActiveTransition);
 },

  componentDidUpdate: function () {
    _.defer(this._triggerActiveTransition);
  },

  _triggerActiveTransition: function () {
    if (this.isMounted()) {
      this.getDOMNode().setAttribute('data-active', this.props.isInLightbox);
    }
  },

  render: function () {
    return (
      <div className={this.getClassName()}
           onClick={this.props.hideLightbox}>
      </div>
    );
  }
});

module.exports = LightboxOverlay;



/** WEBPACK FOOTER **
 ** ./stamp/LightboxOverlay.jsx
 **/